import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getApiKeyForUnits } from '../../../lib/apiKeys';
import s from '../../../redux/selectors';
import types from '../../../types';
import NumericInputWithUnits from './NumericInputWithUnits';

const MultiUnitInput = ({
  unitApiKey,
  unitValue,
  title,
}) => (
  <NumericInputWithUnits
    unitApiKey={unitApiKey}
    title={title}
    apiKey={getApiKeyForUnits(unitApiKey, unitValue.input || unitValue.default)}
  />
);

MultiUnitInput.propTypes = {
  // ownProps
  unitApiKey: PropTypes.string.isRequired,
  title: PropTypes.func.isRequired,
  // connected props
  unitValue: types.UserInput.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'unitValue',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});
const mapDispatchToProps = (_dispatch, _ownProps) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MultiUnitInput);

